<div id="carouselHomePubs" class="carousel slide" data-bs-ride="carousel">
    <div class="carousel-inner">
        <div *ngFor="let chunk of chunkedData; let i = index" class="carousel-item" [class.active]="i === 0">
            <div class="row justify-content-around">
                <div *ngFor="let slideItem of chunk" class="col-12 col-sm-6 col-md-4 col-lg-3 carousel-item-content">
                    <div class="custom-card">
                        <a [href]="'/publicacion/detalle/' + slideItem.id">
                            <img src="{{URL}}{{slideItem.urlimg}}" class="img-fluid carousel-image"
                                alt="{{ slideItem.name }}">
                            <div class="card-caption">
                                <p>{{ slideItem.name }}</p>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <button class="carousel-control-prev" type="button" data-bs-target="#carouselHomePubs" data-bs-slide="prev">
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
        <span class="visually-hidden">Previous</span>
    </button>
    <button class="carousel-control-next" type="button" data-bs-target="#carouselHomePubs" data-bs-slide="next">
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
        <span class="visually-hidden">Next</span>
    </button>
</div>

<div class="col-12 text-end"><a href="/publicacion" class="underline">Ver más publicaciones</a></div>